import { render, staticRenderFns } from "./ComparableSalesDetailsBlock.vue?vue&type=template&id=6b8564d0&scoped=true&"
import script from "./ComparableSalesDetailsBlock.vue?vue&type=script&lang=ts&"
export * from "./ComparableSalesDetailsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./ComparableSalesDetailsBlock.vue?vue&type=style&index=0&id=6b8564d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8564d0",
  null
  
)

export default component.exports